/* ------------------------------------------------------------------
   OO(2026-10-24) 商品ページの「ほかのカラー」（色ちがい）を、
   サイズのボタンのすぐ上へ動かします。

   ■ なにが起きていたか
     色ちがいの枠は 2026-10-12 に作り、商品ページの設定ファイル
     （templates/product.json）の中に置いていました。
     ところが 10月15日より前のどこかで、その設定ファイルが
     まるごと入れ替わったときに、呼び出しの1ブロックごと消えていました。
     （10/15 の見本テーマにも、もう入っていません）

   ■ なぜこの形で戻したか
     商品ページの設定ファイルは 22KB あり、少し直すだけでも
     ファイル全体を書き写すことになって事故が起きやすいためです。
     トップの「選び方の入口」と同じやり方で、
     layout/theme.liquid にいったん出してから、ここで正しい場所へ動かします。

   ■ 中身を作っているのは snippets/brand-color-variants.liquid（触っていません）
     色ちがいが1つしかない商品では、そもそも何も作られません。そのときは何もしません。
------------------------------------------------------------------ */
(function () {
  'use strict';

  function place() {
    var host = document.getElementById('oo-colors-host');
    if (!host) return true;

    var box = host.querySelector('.brandnav-colors');
    if (!box) { host.parentNode && host.parentNode.removeChild(host); return true; }

    var anchor = document.querySelector('.product__variant-picker')
      || document.querySelector('product-variant-selects')
      || document.querySelector('.product-form');
    if (!anchor || !anchor.parentNode) return false;

    anchor.parentNode.insertBefore(box, anchor);
    if (host.parentNode) host.parentNode.removeChild(host);
    return true;
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    if (place()) return;
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (place() || n >= 20) clearInterval(t);
    }, 300);
  });
})();
